import { HttpMethod } from "../types/HttpMethod";

const entityTypeApiUrl = `${process.env.REACT_APP_BASE_URL}/rs/automation/entityType`;

export const getAllEntityTypeList = (auth: string, productCode: string) => {
  const url = `${entityTypeApiUrl}/${productCode}/get`;
  return fetch(url, {
    method: HttpMethod.Get,
    headers: {
      Authorization: auth,
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};
